import React, {useState} from "react";

export const ResponsiveImage = ({
    mediaId,
    alt = "",
    className = null,
    sizes = "(max-width: 768px) 100vw, 700px",
    priority = false,
}) => {
    const [error, setError] = useState(false);
    const resolvedAlt = alt ?? "";
    const loading = priority ? "eager" : "lazy";
    const decoding = "async";

    const isUrl = typeof mediaId === "string" && (mediaId.startsWith("http://") || mediaId.startsWith("https://") || mediaId.startsWith("/"));
    const baseUrl = isUrl ? mediaId.split("?")[0] : `https://ems.dimu.org/image/${mediaId}`;
    const isDimuImage = !isUrl || baseUrl.includes("/image/");

    const src3072 = `${baseUrl}?dimension=3072 3072w`;
    const src2048 = `${baseUrl}?dimension=2048x2048 2048w`;
    const src1024 = `${baseUrl}?dimension=1024x1024 1024w`;
    const src512 = `${baseUrl}?dimension=512 512w`;
    const src1200 = isUrl ? mediaId : `${baseUrl}?dimension=1200x1200`;
    const srcMax = isUrl ? mediaId : `${baseUrl}?dimension=max`;

    const fetchPriority = priority ? "high" : "auto";

    const handleImageError = () => {
        setError(true);
    };

    if (error) {
        return (
            <img
                src={srcMax}
                alt={resolvedAlt}
                className={className}
                sizes={sizes}
                loading={loading}
                decoding={decoding}
                fetchPriority={fetchPriority}
            />
        );
    } else {
        return (
            <img
                srcSet={isDimuImage ? `${src512}, ${src1024}, ${src2048}, ${src3072}` : undefined}
                src={src1200}
                alt={resolvedAlt}
                className={className}
                sizes={sizes}
                loading={loading}
                decoding={decoding}
                fetchPriority={fetchPriority}
                onError={handleImageError}
            />
        );
    }
};